/**
 * App Setup wizard (/app-setup) — waitlist bulk onboarding.
 * Change REACT_APP_APP_SETUP_INVITE_CODE in .env for production.
 */
export const APP_SETUP_STATIC_INVITE_CODE =
  process.env.REACT_APP_APP_SETUP_INVITE_CODE || "RX0HTHTY";

/** Plan assigned automatically after signup in the app-setup wizard. */
export const APP_SETUP_DEFAULT_PLAN_NAME = "Basic";
export const APP_SETUP_DEFAULT_BILLING_CYCLE = "monthly";

export const APP_SETUP_WIZARD_KEY = "app_setup_wizard_active";
export const APP_SETUP_STEP_KEY = "app_setup_wizard_step";
export const APP_SETUP_SIGNUP_KEY = "app_setup_signup_draft";

export const APP_SETUP_STEPS = {
  SIGNUP: "signup",
  PERSONAL_INFO: "personal-info",
  EDUCATION: "education",
  PLATFORM: "platform",
  COMPLETE: "complete",
};
